import * as React from "react";

const RunningHoursService = React.lazy(() => import("./runninghours.container"));

export { RunningHoursService };
